import { render, staticRenderFns } from "./EditNJBPage.vue?vue&type=template&id=77642514&"
import script from "./EditNJBPage.vue?vue&type=script&lang=js&"
export * from "./EditNJBPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports